import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from "../../_services/auth.service";

/**
 * Обработчик возврата с IDP: адрес вида https://sc.egov.kz/?code=...&state=...
 *
 * Код авторизации ОДНОРАЗОВЫЙ. Прежняя версия подписывалась на queryParams в конструкторе,
 * не снимала подписку и не убирала code из адреса — поэтому F5, «назад» или восстановление
 * таба отправляли тот же код повторно, и IDP отвечал invalid_grant.
 */
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  loading = false;
  errorKey: string = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  private goTo(target: string): void {
    this.authService.redirectUrl = '/contracts';
    this.router.navigateByUrl(target);
  }

  ngOnInit() {
    // снимок, а не подписка: повторных срабатываний быть не должно
    const params = this.route.snapshot.queryParams;
    const code = params['code'];
    const state = params['state'];
    const idpError = params['error'];

    if (idpError) {
      this.errorKey = 'Errors.IDP refused authorization';
      return;
    }

    // AuthGuard, отправляя неавторизованного на /landing, запоминает изначально
    // запрошенный URL в authService.redirectUrl — уходим туда, а не жёстко на /contracts
    const target = this.authService.redirectUrl || '/contracts';

    if (!code) {
      this.goTo(target);
      return;
    }

    // Сразу вычищаем code из адресной строки: обновление страницы больше не переотправит его
    this.router.navigate([], {relativeTo: this.route, queryParams: {}, replaceUrl: true});

    if (!this.authService.checkIdpState(state)) {
      this.errorKey = 'Errors.Session expired';
      return;
    }

    if (this.authService.isCodeAlreadySent(code)) {
      // второй заход с тем же кодом — в бэк не идём вовсе
      if (this.authService.isLoggedIn) {
        this.goTo(target);
      } else {
        this.router.navigate(['/landing']);
      }
      return;
    }
    this.authService.markCodeSent(code);

    this.loading = true;
    this.authService.sendCode(code).subscribe(
      user => {
        this.loading = false;
        this.authService.saveUser(user);
        this.goTo(target);
      },
      err => {
        this.loading = false;
        // Ошибку показываем, а не уводим молча: именно из-за этого поломка
        // выглядела «бесконечной загрузкой» вместо внятного отказа
        this.errorKey = err && err.status === 409
          ? 'Errors.Authorization code already used'
          : 'Errors.Authorization failed';
        console.error('get-token failed', err && err.status, err && err.error);
      }
    );
  }

  retry() {
    this.authService.logout();
  }
}
